import { render, staticRenderFns } from "./FaceSwapDetail.vue?vue&type=template&id=1701ff94&scoped=true"
import script from "./FaceSwapDetail.vue?vue&type=script&lang=js"
export * from "./FaceSwapDetail.vue?vue&type=script&lang=js"
import style0 from "./FaceSwapDetail.vue?vue&type=style&index=0&id=1701ff94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1701ff94",
  null
  
)

export default component.exports